export default __webpack_public_path__ + "08aee3f5dfac3dd5b1a0dde3d87c2d21.png";